module.exports = __webpack_public_path__ + "static/media/badge3.b6460884.svg";